// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FBw7","delete":"styles_delete__3wpXk","update":"styles_update__3vEh1","add":"styles_add__1nOxP"};